export enum ActivityHistoryEventType {
  sabalDocumentsUploaded = 'sabal.documents.uploaded',
  sabalDocumentsArchived = 'sabal.documents.archived',
  sabalDocumentsSubmitted = 'sabal.documents.submitted',
  sabalDocumentsRejected = 'sabal.documents.rejected',
  sabalDocumentsReSubmitted = 'sabal.documents.resubmitted',
  sabalDocumentsApproved = 'sabal.documents.approved',
  sabalDocumentsMoved = 'sabal.documents.moved',
  sabalAccountUpdated = 'sabal.account.updated',
  sabalAccountCreated = 'sabal.account.created',
  sabalAccountCancelled = 'sabal.account.cancelled',
  sabalAccountReactivated = 'sabal.account.reactivated',
  cedInvoiceReceived = 'sabal.cedInvoice.received',
  cedShipmentConfirmationReceived = 'sabal.cedShipment.confirmation.received',
  directPayInvoiceReceived = 'sabal.directPayInvoice.received',
  contractCreated = 'sabal-contractCreated',
  contractSent = 'sabal-contractSent',
  contractSigned = 'sabal-contractSigned',
  contractEnvelopeSent = 'sabal-contractEnvelopeSent',
  contractSignerSigned = 'sabal-contractSignerSigned',
  contractVoided = 'sabal-contractVoided',
  congaContractLanguageSet = 'sabal-congaContractLanguageSet',
  congaSigningConsentGiven = 'sabal-congaSigningConsentGiven',
  illinoisDisclosureSent = 'sabal-illinoisDisclosureSent',
  illinoisDisclosureSigned = 'sabal-illinoisDisclosureSigned',
  emailNotificationSent = 'EmailNotificationSent',
  heliosUserInvited = 'helios.user.invited',
  heliosUserCreated = 'helios.user.created',
  solarFlareEmailNotificationSent = 'Solarflare.EmailNotification.Sent',
  solarFlareSmsNotificationSent = 'Solarflare.SmsNotification.Sent',
  sabalQuoteCreated = 'sabal.quote.created',
  sabalQuoteVoided = 'sabal.quote.voided',
  sabalPaymentMethodAdded = 'sabal.paymentMethod.added',
  sabalPaymentFailed = 'sabal.payment.failed',
  sabalAccountMilestoneUpdated = 'sabal.accountMilestone.updated',
  sabalCreditDecisionCompleted = 'sabal.creditDecision.completed',
  sabalCreditDecisionError = 'sabal.creditDecision.error',
  sabalCreditDecisionExpired = 'sabal.creditDecision.expired',
  sabalDesignStipulationFlagged = 'sabal.designStipulation.flagged',
  sabalDesignStipulationCleared = 'sabal.designStipulation.cleared',
  sabalSystemDesignCreated = 'sabal.systemDesign.created',
  sabalAddersUpdated = 'sabal.adders.updated',
  sabalSystemDesignAttested = 'sabal.systemDesign.attested',
  /** @deprecated */
  sabalNTPPackageSubmitted = 'sabal.ntpPackage.submitted',
  /** @deprecated */
  sabalNTPPackageSaved = 'sabal.ntpPackage.saved',
  /** @deprecated */
  sabalNTPPackageResubmitted = 'sabal.ntpPackage.resubmitted',
  sabalInstallPackageSubmitted = 'sabal.installPackage.submitted',
  sabalInstallPackageSaved = 'sabal.installPackage.saved',
  sabalInstallPackageResubmitted = 'sabal.installPackage.resubmitted',
  sabalWarrantyRegistrationSubmitted = 'sabal.warrantyRegistration.submitted',
  sabalActivationPackageSaved = 'sabal.activationPackage.saved',
  sabalActivationPackageSubmitted = 'sabal.activationPackage.submitted',
  sabalActivationPackageResubmitted = 'sabal.activationPackage.resubmitted',
  sabalPermissionToOperateSaved = 'sabal.permissionToOperate.saved',
  sabalPermissionToOperateSubmitted = 'sabal.permissionToOperate.submitted',
  sabalPermissionToOperateResubmitted = 'sabal.permissionToOperate.resubmitted',
  sabalPermissionToOperateCompleted = 'sabal.permissionToOperate.completed',
  sabalElectricianSignOffSaved = 'sabal.electricianSignOff.saved',
  sabalElectricianSignOffResubmitted = 'sabal.electricianSignOff.resubmitted',
  sabalElectricianSignOffSubmitted = 'sabal.electricianSignOff.submitted',
  sabalElectricianSignOffCompleted = 'sabal.electricianSignOff.completed',
  sabalDomesticContentSubmitted = 'sabal.domesticContent.submitted',
  sabalDomesticContentResubmitted = 'sabal.domesticContent.resubmitted',
  sabalDomesticContentCompleted = 'sabal.domesticContent.completed',
  sabalDomesticContentEligibilityStatusUnderConsideration = 'sabal.domesticContentEligibilityStatus.underConsideration',
  sabalDomesticContentEligibilityStatusEpcOptOut = 'sabal.domesticContentEligibilityStatus.epcOptOut',
  sabalDomesticContentEligibilityStatusConfirmed = 'sabal.domesticContentEligibilityStatus.confirmed',
  sabalPostActivationPackageSubmitted = 'sabal.PostActivationPackage.submitted',
  sabalPostActivationPackageResubmitted = 'sabal.postActivationPackage.resubmitted',
  sabalSalesRepUpdated = 'sabal.salesRep.updated',
  sabalSalesRepVerified = 'sabal.salesRep.verified',
  sabalPaymentPlanUpdated = 'sabal.account.paymentPlan.updated',
  sabalDirectPayOptOut = 'sabal.directPay.optOut',
  sabalDirectPayOptIn = 'sabal.directPay.optIn',
  sabalDirectPayOverride = 'sabal.directPay.override',
  sabalAccountUpdatedITCAdderQualifications = 'sabal.account.updated.itcAdderQualifications',
  sabalOperationAtCalculated = 'sabal.operationAt.calculated',
  sabalVerificationDaysCalculated = 'sabal.verificationDays.calculated',
  sabalVerificationDaysExpiredAndReqNoLongerMet = 'sabal.verificationDays.expiredAndReqNoLongerMet',
  sabalPlacedInServiceCalculated = 'sabal.placedInService.calculated',
  sabalEquipmentExceptionGranted = 'sabal.equipmentException.granted',
  sabalEquipmentExceptionModified = 'sabal.equipmentException.modified',
  sabalEquipmentExceptionRemoved = 'sabal.equipmentException.removed',
  sabalLoopFieldPackageSaved = 'sabal.loopFieldPackage.saved',
  sabalLoopFieldPackageSubmitted = 'sabal.loopFieldPackage.submitted',
  sabalLoopFieldPackageResubmitted = 'sabal.loopFieldPackage.resubmitted',
  sabalLoopFieldPackageCompleted = 'sabal.loopFieldPackage.completed',
  sabalSafeHarborBadgeStatusUpdated = 'sabal.safeHarborBadgeStatus.updated',
  sabalLoopFieldDesignDocumentsSubmitted = 'sabal.loopFieldDesignDocuments.submitted',
  sabalLoopFieldDesignDocumentsResubmitted = 'sabal.loopFieldDesignDocuments.resubmitted',
  sabalLoopFieldDesignDocumentsCompleted = 'sabal.loopFieldDesignDocuments.completed',
  sabalLeadAccepted = 'sabal.lead.accepted',
  sabalLeadRejected = 'sabal.lead.rejected',
  messageOpen = 'MessageOpen',
  messageProcessed = 'MessageProcessed',
  messageDelivered = 'MessageDelivered',
}

export enum SabalOrganizationalEvents {
  sabalOrganizationCreated = 'sabal.organization.created',
  sabalOrganizationDirectPayUpdated = 'sabal.organization.directPay.updated',
  sabalOrganizationStatusUpdated = 'sabal.organization.status.updated',
  sabalOrganizationLicensesUpdated = 'sabal.organization.licenses.updated',
  sabalOrganizationUserCreated = 'sabal.organization.user.created',
  sabalOrganizationUserDeleted = 'sabal.organization.user.deleted',
  sabalOrganizationUserPermissionsUpdated = 'sabal.organization.user.permissions.updated',
  sabalOrganizationHoldbackSettingsUpdated = 'sabal.organization.holdbackSettings.updated',
  sabalOrganizationHoldbackSettingsArchived = 'sabal.organization.holdbackSettings.archived',
  sabalOrganizationClawbackSettingsUpdated = 'sabal.organization.clawbackSettings.updated',
  sabalOrganizationInvoiceSettingsUpdated = 'sabal.organization.invoiceSettings.updated',
  sabalOrganizationEquipmentSettingsUpdated = 'sabal.organization.equipmentSettings.updated',
  sabalOrganizationUnderwritingSettingsUpdated = 'sabal.organization.underwritingSettings.updated',
  sabalOrganizationUnderwritingSettingsDeleted = 'sabal.organization.underwritingSettings.deleted',
  sabalOrganizationPaymentPlanUpdated = 'sabal.organization.paymentPlan.updated',
  sabalOrganizationPaymentPlanCancelled = 'sabal.organization.paymentPlan.cancelled',
  sabalOrganizationDomesticContentSettingsUpdated = 'sabal.organization.domesticContentSettings.updated',
  sabalOrganizationDomesticContentSettingsArchived = 'sabal.organization.domesticContentSettings.archived',
  sabalOrganizationPropertyTypePricingSettingsUpdated = 'sabal.organization.propertyTypePricingSettings.updated',
  sabalOrganizationPropertyTypePricingSettingsArchived = 'sabal.organization.propertyTypePricingSettings.archived',
  sabalOrganizationSiteSurveyPricingSettingsUpdated = 'sabal.organization.siteSurveyPricingSettings.updated',
  sabalOrganizationSiteSurveyPricingSettingsArchived = 'sabal.organization.siteSurveyPricingSettings.archived',
  solarFlareEmailNotificationSent = 'Solarflare.EmailNotification.Sent',
  sabalTrancheClosed = 'sabal.tranche.closed',
  accountTrancheUpdate = 'account.tranche.update',
  sabalOrganizationPayoutHoldUpdated = 'sabal.organization.payoutHold.updated',
  sabalOrganizationReviewSlaSettingsUpdated = 'sabal.organization.reviewSlaSettings.updated',
  sabalOrganizationReviewSlaSettingsDisabled = 'sabal.organization.reviewSlaSettings.disabled',
}

export enum SabalInternalEvents {
  sabalIncentiveCreated = 'sabal.incentive.created',
  sabalIncentiveUpdated = 'sabal.incentive.updated',
  sabalAllocationCreated = 'sabal.incentive.allocation.created',
  sabalAllocationUpdated = 'sabal.incentive.allocation.updated',
  sabalAllocationCompleted = 'sabal.incentive.allocation.completed',
  sabalAllocationBlocked = 'sabal.incentive.allocation.blocked',
  sabalAccountsAssignedToAllocation = 'sabal.incentive.allocation.accountsAssigned',
  sabalAccountsUnassignedFromAllocation = 'sabal.incentive.allocation.accountsUnassigned',
  sabalHardwareLookupProcessed = 'sabal.hardwareLookup.processed',
  sabalPreBillingCustomerAdjustmentApplied = 'sabal.preBillingCustomerAdjustment.applied',
  sabalPreBillingCustomerAdjustmentOfferSent = 'sabal.preBillingCustomerAdjustment.offerSent',
  sabalPreBillingCustomerAdjustmentAccepted = 'sabal.preBillingCustomerAdjustment.accepted',
  sabalPreBillingCustomerAdjustmentExpired = 'sabal.preBillingCustomerAdjustment.expired',
  sabalPreBillingCustomerAdjustmentVoided = 'sabal.preBillingCustomerAdjustment.voided',
  sabalPreBillingCustomerAdjustmentReinstated = 'sabal.preBillingCustomerAdjustment.reinstated',
  sabalChangeOrderCreated = 'sabal.changeOrder.created',
  sabalChangeOrderEmailSent = 'sabal.changeOrder.emailSent',
  sabalChangeOrderSmsSent = 'sabal.changeOrder.smsSent',
  sabalChangeOrderViewed = 'sabal.changeOrder.viewed',
  sabalChangeOrderAccepted = 'sabal.changeOrder.accepted',
  sabalChangeOrderDeclined = 'sabal.changeOrder.declined',
  sabalChangeOrderEmailed = 'sabal.changeOrder.emailed',
  sabalChangeOrderSmsed = 'sabal.changeOrder.smsed',
  sabalChangeOrderReminderSent = 'sabal.changeOrder.reminderSent',
  sabalChangeOrderResendSent = 'sabal.changeOrder.resendSent',
  sabalChangeOrderExpired = 'sabal.changeOrder.expired',
  sabalChangeOrderExecuted = 'sabal.changeOrder.executed',
  sabalChangeOrderCancelled = 'sabal.changeOrder.cancelled',
  sabalChangeOrderVoided = 'sabal.changeOrder.voided',
  sabalChangeOrderEpcNotified = 'sabal.changeOrder.epcNotifiedAcceptance',
  sabalChangeOrderCustomerNotified = 'sabal.changeOrder.customerNotifiedAcceptance',
  sabalUtilityBillExtractionProcessed = 'sabal.utilityBill.extraction.processed',
  sabalOneTimePaymentScheduled = 'sabal.oneTimePayment.scheduled',
  sabalOneTimePaymentCancelled = 'sabal.oneTimePayment.cancelled',
  dispatchAcceptedByOrganization = 'dispatch.acceptedByOrganization',
  sabalDirectPaymentLinkCreated = 'sabal.directPaymentLink.created',
  sabalDirectPaymentLinkEmailed = 'sabal.directPaymentLink.emailed',
  sabalDirectPaymentLinkSmsed = 'sabal.directPaymentLink.smsed',
  sabalDirectPaymentLinkDeactivated = 'sabal.directPaymentLink.deactivated',
  sabalDirectPaymentLinkGenerated = 'sabal.directPaymentLink.generated',
  welcomeCallApproved = 'sabal.welcomeCall.approved',
  welcomeCallRejected = 'sabal.welcomeCall.rejected',
  welcomeCallRecheckPassed = 'sabal.welcomeCall.recheckPassed',
  welcomeCallRecheckFailed = 'sabal.welcomeCall.recheckFailed',
}

export enum SabalEventType {
  sabalHoldbackCreated = 'holdback.created',
  sabalHoldbackUpdated = 'holdback.updated',
  sabalModifierUpdated = 'modifier.updated',
  sabalModifierCreated = 'modifier.created',
  sabalPriceSheetsMappingsArchived = 'modifier.pricesheet.mappings.archived',
  sabalPriceSheetsMappingsCreated = 'modifier.pricesheet.mappings.created',
  sabalConstructionAdderUpdated = 'construction.adder.updated',
  sabalConstructionAdderCreated = 'construction.adder.created',
  sabalPriceSheetCreated = 'pricesheet.created',
  sabalPriceSheetUpdated = 'pricesheet.updated',
  warrantyPricingCreated = 'warrantyPricing.created',
  warrantyPricingArchived = 'warrantyPricing.archived',
  sabalEnergyBackupCapCreated = 'energyBackupCap.created',
  sabalEnergyBackupCapUpdated = 'energyBackupCap.updated',
}

export enum ActivityEventAssociatedEntityType {
  SabalAccountId = 'sabalAccountId',
  SabalSystemDesign = 'sabalSystemDesign',
  SabalApplicationId = 'sabalApplicationId',
  SabalDocumentId = 'sabalDocumentId',
  SabalContractId = 'sabalContractId',
  SabalQuoteId = 'sabalQuoteId',
  SabalSalesRep = 'sabalSalesRep',
  SabalOrganizationId = 'sabalOrganizationId',
}

/**
 * Markers the backend writes into an activity-history diff and the frontend reads back out.
 * They live here because both sides must agree on the literal — a hand-copied string that drifts
 * silently breaks redaction display and identity labelling.
 */

/** Stands in for a SOC 2-sensitive value that changed, so the value itself is never persisted. */
export const REDACTED_DIFF_VALUE = '[redacted]';

/** Attached to array elements matched by identity rather than position, naming which one changed. */
export const DIFF_IDENTITY_KEY = '_identity';

/** A changed field: the value before and after. */
export type DiffLeaf = { from: unknown; to: unknown };

/** An object subtree: one entry per changed field. */
export type DiffRecord = { [field: string]: DiffNode };

/**
 * One slot of a diffed array. Index-matched arrays are sparse, so unchanged positions serialize as
 * null; identity-matched elements carry DIFF_IDENTITY_KEY naming which element they are.
 */
export type DiffArrayElement = (DiffNode & { [DIFF_IDENTITY_KEY]?: string }) | null | undefined;

export type DiffNode = DiffLeaf | DiffRecord | DiffArrayElement[];

/** True for a changed-field node. Both sides read "leaf" from here so the shape cannot drift. */
export const isDiffLeaf = (node: unknown): node is DiffLeaf =>
  typeof node === 'object' &&
  node !== null &&
  !Array.isArray(node) &&
  (Object.hasOwn(node, 'from') || Object.hasOwn(node, 'to'));
